import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.4 3.006 9.4.073a.87.87 0 0 0-.7 0l-8 2.933c-.4.098-.7.49-.7.88v6.843c0 6.354 8.2 10.46 8.6 10.656.1.098.2.098.4.098s.3 0 .4-.098c.4-.196 8.6-4.302 8.6-10.656V3.886c0-.39-.3-.782-.6-.88M16 10.73c0 4.4-5.4 7.723-7 8.7-1.6-.88-7-4.203-7-8.7V4.57l7-2.54 7 2.54z"
    }, null, -1)
  ]))]))
}
export default { render: render }